<template>
  <div class="history-retrieval">
    <div class="history-retrieval-title-warp">
      <div class="title">{{$t('retrieval.historyRetrieval')}}：</div>
      <el-button class="clear-btn" type="primary" @click="handleClearHistory">{{$t('common.reset')}}
      </el-button>
    </div>
    <ul class="history-retrieval-container">
      <li v-for="(item,index) in historyRetrievalList" :key="index"
          class="history-retrieval-container_item" @click="handleClickHistory($event)">
        {{item.keyword}}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HistoryRetrieval',
  props: {
    // 点击的记录内容
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  watch: {

  },
  computed: {
    historyRetrievalList() {
      return this.data
    }
  },
  methods: {
    handleClickHistory(e) {
      this.$emit('handleRetrievalHistory', e.target.innerText)
    },
    handleClearHistory() {
      this.$emit('handleClearHistory')
    }
  },
}
</script>

<style lang="less" scoped>
.history-retrieval {
  width: 100%;
  padding: 0 0.72em;
  height: 100%;
  box-sizing: border-box;
  &-title-warp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      color: #454545;
    }
    .clear-btn {
      padding: 8px 15px;
    }
  }
  &-container {
    width: 100%;
    height: calc(100% - 32px);
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow-y: auto;
    &_item {
      margin-top: 0.72em;
      margin-right: 1.43em;
      padding: 5px 14px;
      box-sizing: border-box;
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: 32px;
      line-height: 1.4;
      color: #999;
      border-radius: 4px;
      border: 1px solid #e5e7eb;
      cursor: pointer;
      &:hover {
        color: #454545;
      }
    }
  }
}
</style>